module.exports = __webpack_public_path__ + "static/img/ls18.5befae7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls18.png
// module id = 1ZfC
// module chunks = 12